import React from "react";
import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
import { cn } from "@/lib/utils";

interface TimePickerProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

const TimePickerComponent: React.FC<TimePickerProps> = ({
  value,
  onChange,
  placeholder = "Select time...",
  className = "",
  disabled = false,
}) => {
  const handleChange = (newValue: any) => {
    onChange(newValue || "");
  };

  return (
    <div className={cn("relative", className)}>
      <TimePicker
        value={value}
        onChange={handleChange}
        disableClock={false}
        format="HH:mm"
        clearIcon={null}
        clockIcon={null}
        disabled={disabled}
        className={cn("w-full", disabled && "opacity-50 cursor-not-allowed")}
      />
    </div>
  );
};

export default TimePickerComponent;
